import type { AnalyticEventName } from 'modules/analytics/analytics';

export const JACKET_TYPE = {
  PATIENT: 'patient',
  SEARCH: 'search',
} as const;

export type JacketType = (typeof JACKET_TYPE)[keyof typeof JACKET_TYPE];

export interface JacketMarks {
  start: string;
  worklist_item_fetch: string;
  paint: string;
  select_prior: string;
  selected_prior_load: string;
  selected_prior_paint: string;
  priors_summary_start: string;
  priors_summary_load: string;
  priors_summary_paint: string;
}

export interface JacketMeasure {
  metricName: string;
  startMarkName: string;
  endMarkName: string;
}

export interface JacketMeasures {
  timeToWorklistItemData: JacketMeasure;
  timeToSelectedPriorLoad: JacketMeasure;
  timeToSelectedPriorPaint: JacketMeasure;
  timeToPaint: JacketMeasure;
  timeToPriorsSummaryPaint: JacketMeasure;
  timeToPriorsSummaryLoad: JacketMeasure;
}

export interface JacketAnalyticsActions {
  togglePanel: AnalyticEventName;
  toggleTab: AnalyticEventName;
  downloadReport?: AnalyticEventName;
}
